import {CopyrightOutlined} from '@ant-design/icons'
import MessageBlock from '@/components/MessageBlock'
import icon1 from '@/assets/images/layouts/footer-1.jpg'
import icon2 from '@/assets/images/layouts/footer-2.jpg'
import icon3 from '@/assets/images/layouts/footer-3.jpg'
import icon4 from '@/assets/images/layouts/footer-4.jpg'
import footerIcon from '@/assets/images/layouts/dealer-footer-icon.png'
import styles from '@/layouts/style.module.less'
import { Col, Row } from 'antd'

const DealerFooter = () => {
  return (
    <div className={styles['footer']}>
      <div className='layout-container text-white'>
        <div className='flex align-center pt-30 pb-20 border-bottom' style={{borderColor: '#555'}}>
          <a href="http://www.youtube.com/@medelielectronics907" target='_blank' rel="noreferrer">
            <img className={`${styles['footer-link-menu-icon']} mlr-10`} src={icon1} alt='' />
          </a>
          <a href="https://www.facebook.com/MedeliElectronics" target='_blank' rel="noreferrer">
            <img className={`${styles['footer-link-menu-icon']} mlr-10`} src={icon2} alt='' />
          </a>
          <a href="https://www.instagram.com/medeliofficial" target='_blank' rel="noreferrer">
            <img className={`${styles['footer-link-menu-icon']} mlr-10`} src={icon3} alt='' />
          </a>
          <a href="https://soundcloud.com/medeliofficial" target='_blank' rel="noreferrer">
            <img className={`${styles['footer-link-menu-icon']} mlr-10`} src={icon4} alt='' />
          </a>
          <div className='flex-1'></div>
          {/* <img src={footerIcon} style={{height: '80px'}} alt='' /> */}
        </div>
        <Row className='text-aaa mt-30 pb-30'>
          <Col span={4}>
            <MessageBlock
              title='PRODUCTS'
              items={
                [
                  {
                    href: '/category/DigitalPianos', 
                    text: 'Digital Pianos'
                  }, {
                    href: '/category/Keyboards', 
                    text: 'Keyboards'
                  }, {
                    href: '/category/Drums',
                    text: 'Rhythm Machines'
                  }]
              }
            />
          </Col>
          <Col span={4}>
            <MessageBlock
              title='Find A Store'
              items={
                [{href: '/dealer/distributor', text: 'Dealer stores'}]
              }
            />
          </Col>
          <Col span={4}>
            <MessageBlock
              title='NEWS'
              items={
                [{href: '/news?t=u', text: 'Update'}]
              }
            />
          </Col>
          <Col span={4}>
            <MessageBlock
              title='SUPPORT'
              items={
                [{href: '/support', text: 'Download'}, {href: '/contactus', text: 'Contact Us'}]
              }
            />
          </Col>
          <Col span={4}>
            <MessageBlock
              title='ABOUT US'
              items={
                [{href: '/aboutus/companyoverview', text: 'Brand Story'}, {text: 'Team', href: '/aboutus/team'}, {text: 'Technology', href: '/aboutus/technology'}, {text: 'Medeli Park', href: '/aboutus/medelipark'}]
              }
            />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default DealerFooter
